import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["custom"],
  _excluded2 = ["custom"],
  _excluded3 = ["custom"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
import useUiState from '~/composables/useUiState';
import { useNuxt2App } from '~/composables/useNuxt2App';
import { useCartPopup } from '~/composables/_next/cart/useCartPopup';
import { useStoreCustomer } from '~/composables/_next/stores/useStoreCustomer';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import { isProductAvailableInCountry } from '~/utils/ProductAvailability';
export function useCart() {
  var _useNuxt2App = useNuxt2App(),
    nuxt2Context = _useNuxt2App.app,
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    currency = _useLocalization.currency,
    locale = _useLocalization.locale;
  var router = useRouter();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useStoreCustomer = useStoreCustomer(),
    user = _useStoreCustomer.user,
    cart = _useStoreCustomer.cart,
    setCart = _useStoreCustomer.setCart;
  var _useUiState = useUiState(),
    showCartPopup = _useUiState.showCartPopup;
  var loading = useState('useCart-loading', function () {
    return false;
  });
  var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
    isTalonOneEnabled = _useFeatureFlagTalonO.isTalonOneEnabled;
  var error = useState('useCart-error', function () {
    return {
      addItem: null,
      removeItem: null,
      updateItemQty: null,
      create: null,
      load: null,
      clear: null,
      applyCoupon: null,
      removeCoupon: null
    };
  });
  function load() {
    return _load.apply(this, arguments);
  }
  function _load() {
    _load = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var reload,
        _cart,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            reload = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            if (!(cart.value && !reload)) {
              _context.next = 5;
              break;
            }
            loading.value = false;
            error.value.load = null;
            return _context.abrupt("return");
          case 5:
            _context.prev = 5;
            loading.value = true;
            _context.next = 9;
            return client.cart.getActiveCartFull.query({
              customerGroupValue: process.env.CUSTOMER_GROUP_WITHOUT_VAT
            });
          case 9:
            _cart = _context.sent;
            setCart(_cart);
            error.value.load = null;
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            $sentry.captureException(error);
            error.value.load = _context.t0;
          case 18:
            _context.prev = 18;
            loading.value = false;
            return _context.finish(18);
          case 21:
            _context.next = 23;
            return attachCustomerExternalId();
          case 23:
            return _context.abrupt("return", cart.value);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 14, 18, 21]]);
    }));
    return _load.apply(this, arguments);
  }
  function attachCustomerExternalId() {
    return _attachCustomerExternalId.apply(this, arguments);
  }
  function _attachCustomerExternalId() {
    _attachCustomerExternalId = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _cart$value$custom, externalIdField, _cart$value$customer, id;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(cart.value && isTalonOneEnabled.value)) {
              _context2.next = 8;
              break;
            }
            externalIdField = (_cart$value$custom = cart.value.custom) === null || _cart$value$custom === void 0 ? void 0 : _cart$value$custom.customFieldsRaw.find(function (_ref8) {
              var name = _ref8.name;
              return name === 'customerExternalId';
            });
            if (externalIdField) {
              _context2.next = 8;
              break;
            }
            id = (_cart$value$customer = cart.value.customer) === null || _cart$value$customer === void 0 ? void 0 : _cart$value$customer.externalId;
            _context2.t0 = id;
            if (!_context2.t0) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return updateCartCustomFields([{
              name: 'customerExternalId',
              value: JSON.stringify(id)
            }]);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _attachCustomerExternalId.apply(this, arguments);
  }
  function createCart() {
    return _createCart.apply(this, arguments);
  }
  function _createCart() {
    _createCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var cart;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.cart.createCart.mutate({
              locale: locale,
              country: country,
              currency: currency
            });
          case 2:
            cart = _context3.sent;
            setCart(cart);
            return _context3.abrupt("return", cart);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _createCart.apply(this, arguments);
  }
  function getCurrentCart() {
    return _getCurrentCart.apply(this, arguments);
  }
  function _getCurrentCart() {
    _getCurrentCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!cart.value) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", cart.value);
          case 2:
            _context4.next = 4;
            return createCart();
          case 4:
            return _context4.abrupt("return", _context4.sent);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _getCurrentCart.apply(this, arguments);
  }
  function clear() {
    return _clear.apply(this, arguments);
  }
  function _clear() {
    _clear = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var deletedCart;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (cart.value) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.next = 4;
            return client.cart.deleteCart.mutate();
          case 4:
            deletedCart = _context5.sent;
            setCart(null);
            return _context5.abrupt("return", deletedCart);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _clear.apply(this, arguments);
  }
  function addItem(_x) {
    return _addItem.apply(this, arguments);
  }
  function _addItem() {
    _addItem = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref) {
      var _user$value;
      var product, quantity, params, updatedCart;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            product = _ref.product, quantity = _ref.quantity;
            params = {
              product: product,
              quantity: quantity
            };
            _context6.next = 4;
            return client.cart.addToCart.mutate(_objectSpread(_objectSpread({}, params), {}, {
              locale: locale,
              country: country,
              currency: currency,
              customerExternalId: (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.externalId
            }));
          case 4:
            updatedCart = _context6.sent;
            updatedCart && setCart(updatedCart);
            return _context6.abrupt("return", updatedCart);
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _addItem.apply(this, arguments);
  }
  function removeItem(_x2) {
    return _removeItem.apply(this, arguments);
  }
  function _removeItem() {
    _removeItem = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref2) {
      var product, updatedCart;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            product = _ref2.product;
            _context7.next = 3;
            return getCurrentCart();
          case 3:
            _context7.next = 5;
            return client.cart.removeItem.mutate({
              id: product.id,
              quantity: product.quantity
            });
          case 5:
            updatedCart = _context7.sent;
            updatedCart && setCart(updatedCart);
            return _context7.abrupt("return", updatedCart);
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _removeItem.apply(this, arguments);
  }
  function updateItemQty(_x3) {
    return _updateItemQty.apply(this, arguments);
  }
  function _updateItemQty() {
    _updateItemQty = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref3) {
      var product, quantity, updatedCart;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            product = _ref3.product, quantity = _ref3.quantity;
            if (!(quantity && quantity > 0)) {
              _context8.next = 8;
              break;
            }
            _context8.next = 4;
            return getCurrentCart();
          case 4:
            _context8.next = 6;
            return client.cart.updateCartQuantity.mutate({
              product: _objectSpread(_objectSpread({}, product), {}, {
                quantity: quantity
              })
            });
          case 6:
            updatedCart = _context8.sent;
            setCart(updatedCart);
          case 8:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _updateItemQty.apply(this, arguments);
  }
  function isInCart(_ref4) {
    var _cart$value;
    var product = _ref4.product;
    return ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.lineItems.findIndex(function (item) {
      return item.productId === product._id;
    })) > -1;
  }
  var totalPriceCart = computed(function () {
    var _cart$value2, _cart$value2$totalPri;
    var isTotalPriceValidNumber = !isNaN((_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : (_cart$value2$totalPri = _cart$value2.totalPrice) === null || _cart$value2$totalPri === void 0 ? void 0 : _cart$value2$totalPri.centAmount);
    return isTotalPriceValidNumber ? cart.value.totalPrice.centAmount / 100 : null;
  });
  var totalPriceItems = computed(function () {
    var _cart$value$lineItems, _cart$value3, _cart$value3$lineItem;
    var totalAmount = (_cart$value$lineItems = (_cart$value3 = cart.value) === null || _cart$value3 === void 0 ? void 0 : (_cart$value3$lineItem = _cart$value3.lineItems) === null || _cart$value3$lineItem === void 0 ? void 0 : _cart$value3$lineItem.reduce(function (acc, item) {
      var _item$taxedPrice$tota, _item$taxedPrice, _item$taxedPrice$tota2;
      var itemPrice = (_item$taxedPrice$tota = item === null || item === void 0 ? void 0 : (_item$taxedPrice = item.taxedPrice) === null || _item$taxedPrice === void 0 ? void 0 : (_item$taxedPrice$tota2 = _item$taxedPrice.totalGross) === null || _item$taxedPrice$tota2 === void 0 ? void 0 : _item$taxedPrice$tota2.centAmount) !== null && _item$taxedPrice$tota !== void 0 ? _item$taxedPrice$tota : 0;
      return acc + itemPrice;
    }, 0)) !== null && _cart$value$lineItems !== void 0 ? _cart$value$lineItems : 0;
    return totalAmount / 100;
  });
  var countItems = computed(function () {
    var _cart$value$lineItems2, _cart$value4, _cart$value4$lineItem;
    var quantity = (_cart$value$lineItems2 = (_cart$value4 = cart.value) === null || _cart$value4 === void 0 ? void 0 : (_cart$value4$lineItem = _cart$value4.lineItems) === null || _cart$value4$lineItem === void 0 ? void 0 : _cart$value4$lineItem.reduce(function (acc, item) {
      var _item$quantity;
      return acc + ((_item$quantity = item === null || item === void 0 ? void 0 : item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 0);
    }, 0)) !== null && _cart$value$lineItems2 !== void 0 ? _cart$value$lineItems2 : 0;
    return quantity;
  });
  var countItemsWithoutGift = computed(function () {
    var _cart$value$lineItems3, _cart$value5, _cart$value5$lineItem;
    var countRejectedGiftItems = (_cart$value$lineItems3 = (_cart$value5 = cart.value) === null || _cart$value5 === void 0 ? void 0 : (_cart$value5$lineItem = _cart$value5.lineItems) === null || _cart$value5$lineItem === void 0 ? void 0 : _cart$value5$lineItem.filter(function (item) {
      var _item$custom, _item$custom$type, _item$custom$customFi, _item$custom$customFi2;
      return ((_item$custom = item.custom) === null || _item$custom === void 0 ? void 0 : (_item$custom$type = _item$custom.type) === null || _item$custom$type === void 0 ? void 0 : _item$custom$type.key) === 'gifting' && ((_item$custom$customFi = item.custom.customFieldsRaw) === null || _item$custom$customFi === void 0 ? void 0 : (_item$custom$customFi2 = _item$custom$customFi.find(function (prop) {
        return prop.name === 'rejected';
      })) === null || _item$custom$customFi2 === void 0 ? void 0 : _item$custom$customFi2.value) === true;
    }).length) !== null && _cart$value$lineItems3 !== void 0 ? _cart$value$lineItems3 : 0;
    var count = countItems.value - countRejectedGiftItems;
    if (count < 0) {
      return 0;
    }
    return count;
  });
  var hasWorkshopsInCart = computed(function () {
    var _cart$value$lineItems4, _cart$value6, _cart$value6$lineItem;
    return (_cart$value$lineItems4 = (_cart$value6 = cart.value) === null || _cart$value6 === void 0 ? void 0 : (_cart$value6$lineItem = _cart$value6.lineItems) === null || _cart$value6$lineItem === void 0 ? void 0 : _cart$value6$lineItem.every(function (item) {
      var _item$productType;
      return ((_item$productType = item.productType) === null || _item$productType === void 0 ? void 0 : _item$productType.key) === 'atelier';
    })) !== null && _cart$value$lineItems4 !== void 0 ? _cart$value$lineItems4 : false;
  });
  var cartExpirationDate = computed(function () {
    var _cart$value7;
    var date = new Date((_cart$value7 = cart.value) === null || _cart$value7 === void 0 ? void 0 : _cart$value7.createdAt);
    date.setMinutes(date.getMinutes() + 30);
    return date;
  });

  // TODO: remove this along with feature flag 'enableTalonOne'
  var cartCoupons = computed(function () {
    var _cart$value$discountC, _cart$value8;
    return (_cart$value$discountC = (_cart$value8 = cart.value) === null || _cart$value8 === void 0 ? void 0 : _cart$value8.discountCodes) !== null && _cart$value$discountC !== void 0 ? _cart$value$discountC : [];
  });
  var freeShippingCoupons = computed(function () {
    return cartCoupons.value.filter(function (discountCodeInfo) {
      var discountCode = discountCodeInfo === null || discountCodeInfo === void 0 ? void 0 : discountCodeInfo.discountCode.code.toLowerCase();
      return discountCode.startsWith('hello') || discountCode.startsWith('liv');
    });
  });
  function updateCartCustomFields(_x4) {
    return _updateCartCustomFields.apply(this, arguments);
  }
  /**
   * Rejects the given product.
   */
  function _updateCartCustomFields() {
    _updateCartCustomFields = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(fields) {
      var _cart$value9;
      var actions, updatedCart;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return getCurrentCart();
          case 2:
            actions = [];
            if (cart.value.custom) {
              actions.push.apply(actions, _toConsumableArray(fields.map(function (field) {
                return {
                  setCustomField: field
                };
              })));
            } else {
              actions.push({
                setCustomType: {
                  type: {
                    key: 'order_additional_fields'
                  },
                  fields: fields
                }
              });
            }
            _context9.next = 6;
            return client.cart.updateCart.mutate({
              actions: (_cart$value9 = cart.value) !== null && _cart$value9 !== void 0 && _cart$value9.custom ? fields.map(function (field) {
                return {
                  setCustomField: field
                };
              }) : {
                setCustomType: {
                  type: {
                    key: 'order_additional_fields'
                  },
                  fields: fields
                }
              }
            });
          case 6:
            updatedCart = _context9.sent;
            setCart(updatedCart);
            return _context9.abrupt("return", updatedCart);
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _updateCartCustomFields.apply(this, arguments);
  }
  function setGiftRejection(_x5, _x6) {
    return _setGiftRejection.apply(this, arguments);
  }
  function _setGiftRejection() {
    _setGiftRejection = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(product, value) {
      var updatedCart;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return getCurrentCart();
          case 2:
            _context10.next = 4;
            return client.cart.setGiftRejection.mutate({
              lineItemId: product.id,
              isRejected: value
            });
          case 4:
            updatedCart = _context10.sent;
            setCart(updatedCart);
            return _context10.abrupt("return", updatedCart);
          case 7:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _setGiftRejection.apply(this, arguments);
  }
  var _useCartPopup = useCartPopup(),
    lastAddedItems = _useCartPopup.lastAddedItems,
    resetLastAddedItems = _useCartPopup.resetLastAddedItems,
    addLastItem = _useCartPopup.addLastItem;
  function addItemById(_x7) {
    return _addItemById.apply(this, arguments);
  }
  function _addItemById() {
    _addItemById = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(params) {
      var product, quantity, showConfirmation, id, sku;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            product = params.product, quantity = params.quantity, showConfirmation = params.showConfirmation;
            id = product.id, sku = product.sku;
            _context11.next = 4;
            return addItem({
              product: {
                id: id,
                sku: sku
              },
              quantity: quantity
            });
          case 4:
            resetLastAddedItems();
            addLastItem({
              product: product,
              quantity: quantity
            });
            if (showConfirmation && lastAddedItems.value.length > 0) {
              showCartPopup();
            }
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _addItemById.apply(this, arguments);
  }
  function addItemsById(_x8) {
    return _addItemsById.apply(this, arguments);
  }
  /**
   * Removes an items if not available in the given country.
   */
  function _addItemsById() {
    _addItemsById = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(params) {
      var productList, showConfirmation, _iterator, _step, _step$value, product, quantity, id, sku;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            productList = params.productList, showConfirmation = params.showConfirmation;
            resetLastAddedItems();
            _iterator = _createForOfIteratorHelper(productList);
            _context12.prev = 3;
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context12.next = 13;
              break;
            }
            _step$value = _step.value, product = _step$value.product, quantity = _step$value.quantity;
            id = product.id, sku = product.sku;
            _context12.next = 10;
            return addItem({
              product: {
                id: id,
                sku: sku
              },
              quantity: quantity
            });
          case 10:
            addLastItem({
              product: product,
              quantity: quantity
            });
          case 11:
            _context12.next = 5;
            break;
          case 13:
            _context12.next = 18;
            break;
          case 15:
            _context12.prev = 15;
            _context12.t0 = _context12["catch"](3);
            _iterator.e(_context12.t0);
          case 18:
            _context12.prev = 18;
            _iterator.f();
            return _context12.finish(18);
          case 21:
            if (showConfirmation && lastAddedItems.value.length > 0) {
              showCartPopup();
            }
          case 22:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[3, 15, 18, 21]]);
    }));
    return _addItemsById.apply(this, arguments);
  }
  function removeItemsIfNotAvailableInCountry(_x9) {
    return _removeItemsIfNotAvailableInCountry.apply(this, arguments);
  }
  /**
   * Adds a workshop to the cart.
   */
  function _removeItemsIfNotAvailableInCountry() {
    _removeItemsIfNotAvailableInCountry = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(products) {
      var _cart$value10, _cart$value10$lineIte;
      var country,
        returnToHome,
        _iterator2,
        _step2,
        cartProduct,
        _args13 = arguments;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            country = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
            returnToHome = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : false;
            _context13.next = 4;
            return load(true);
          case 4:
            _iterator2 = _createForOfIteratorHelper(products);
            _context13.prev = 5;
            _iterator2.s();
          case 7:
            if ((_step2 = _iterator2.n()).done) {
              _context13.next = 14;
              break;
            }
            cartProduct = _step2.value;
            if (isProductAvailableInCountry(cartProduct.variant, country)) {
              _context13.next = 12;
              break;
            }
            _context13.next = 12;
            return removeItem({
              product: cartProduct
            });
          case 12:
            _context13.next = 7;
            break;
          case 14:
            _context13.next = 19;
            break;
          case 16:
            _context13.prev = 16;
            _context13.t0 = _context13["catch"](5);
            _iterator2.e(_context13.t0);
          case 19:
            _context13.prev = 19;
            _iterator2.f();
            return _context13.finish(19);
          case 22:
            if (returnToHome && !((_cart$value10 = cart.value) !== null && _cart$value10 !== void 0 && (_cart$value10$lineIte = _cart$value10.lineItems) !== null && _cart$value10$lineIte !== void 0 && _cart$value10$lineIte.length)) {
              router.push(nuxt2Context.localePath({
                name: 'index'
              }));
            }
          case 23:
          case "end":
            return _context13.stop();
        }
      }, _callee13, null, [[5, 16, 19, 22]]);
    }));
    return _removeItemsIfNotAvailableInCountry.apply(this, arguments);
  }
  function addWorkshopToCart(_x10) {
    return _addWorkshopToCart.apply(this, arguments);
  }
  function _addWorkshopToCart() {
    _addWorkshopToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(data) {
      var updatedCart;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return createCart();
          case 2:
            _context14.prev = 2;
            _context14.next = 5;
            return client.cart.addWorkshop.mutate(_objectSpread(_objectSpread({}, data), {}, {
              locale: locale,
              country: country,
              currency: currency
            }));
          case 5:
            updatedCart = _context14.sent;
            setCart(updatedCart);
            _context14.next = 15;
            break;
          case 9:
            _context14.prev = 9;
            _context14.t0 = _context14["catch"](2);
            $sentry.setContext('error', _context14.t0);
            $sentry.setContext('data', data);
            $sentry.captureException(new Error('useCart: cannot add workshop'));
            throw _context14.t0;
          case 15:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[2, 9]]);
    }));
    return _addWorkshopToCart.apply(this, arguments);
  }
  function addUtms(fields) {
    return updateCartCustomFields(fields);
  }
  function updateCartLocaleAndCountry(_x11) {
    return _updateCartLocaleAndCountry.apply(this, arguments);
  }
  function _updateCartLocaleAndCountry() {
    _updateCartLocaleAndCountry = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref5) {
      var locale, country, actions, updatedCart;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            locale = _ref5.locale, country = _ref5.country;
            _context15.next = 3;
            return getCurrentCart();
          case 3:
            actions = [];
            if (locale) {
              actions.push({
                setLocale: {
                  locale: locale
                }
              });
            }
            if (country) {
              actions.push({
                setCountry: {
                  country: country
                }
              });
            }
            _context15.next = 8;
            return client.cart.updateCart.mutate({
              actions: actions
            });
          case 8:
            updatedCart = _context15.sent;
            updatedCart && setCart(updatedCart);
            return _context15.abrupt("return", updatedCart);
          case 11:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _updateCartLocaleAndCountry.apply(this, arguments);
  }
  function setCustomerEmail(_x12) {
    return _setCustomerEmail.apply(this, arguments);
  }
  function _setCustomerEmail() {
    _setCustomerEmail = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(email) {
      var updatedCart;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return getCurrentCart();
          case 2:
            _context16.next = 4;
            return client.cart.updateCart.mutate({
              actions: [{
                setCustomerEmail: {
                  email: email
                }
              }]
            });
          case 4:
            updatedCart = _context16.sent;
            updatedCart && setCart(updatedCart);
            return _context16.abrupt("return", updatedCart);
          case 7:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return _setCustomerEmail.apply(this, arguments);
  }
  function updateShippingAddress(_x13) {
    return _updateShippingAddress.apply(this, arguments);
  }
  function _updateShippingAddress() {
    _updateShippingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(address) {
      var custom, cleanedAddress, updatedCart;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return getCurrentCart();
          case 2:
            custom = address.custom, cleanedAddress = _objectWithoutProperties(address, _excluded);
            _context17.next = 5;
            return client.cart.setShippingAddress.mutate({
              locale: locale,
              currency: currency,
              address: cleanedAddress
            });
          case 5:
            updatedCart = _context17.sent;
            updatedCart && setCart(updatedCart);
            return _context17.abrupt("return", updatedCart);
          case 8:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    return _updateShippingAddress.apply(this, arguments);
  }
  function updateBillingAddress(_x14) {
    return _updateBillingAddress.apply(this, arguments);
  }
  function _updateBillingAddress() {
    _updateBillingAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18(address) {
      var custom, cleanedAddress, updatedCart;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return getCurrentCart();
          case 2:
            custom = address.custom, cleanedAddress = _objectWithoutProperties(address, _excluded2);
            _context18.next = 5;
            return client.cart.setBillingAddress.mutate({
              locale: locale,
              currency: currency,
              address: cleanedAddress
            });
          case 5:
            updatedCart = _context18.sent;
            updatedCart && setCart(updatedCart);
            return _context18.abrupt("return", updatedCart);
          case 8:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return _updateBillingAddress.apply(this, arguments);
  }
  function updateShippingProvider(_x15) {
    return _updateShippingProvider.apply(this, arguments);
  }
  function _updateShippingProvider() {
    _updateShippingProvider = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee19(_ref6) {
      var id, deliveryDate, updatedCart;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            id = _ref6.id, deliveryDate = _ref6.deliveryDate;
            _context19.next = 3;
            return getCurrentCart();
          case 3:
            if (!deliveryDate) {
              _context19.next = 6;
              break;
            }
            _context19.next = 6;
            return updateCartCustomFields([{
              name: 'delivery-date',
              value: JSON.stringify(deliveryDate)
            }]);
          case 6:
            _context19.next = 8;
            return client.cart.setShippingMethod.mutate({
              locale: locale,
              currency: currency,
              shippingMethodId: id
            });
          case 8:
            updatedCart = _context19.sent;
            updatedCart && setCart(updatedCart);
            return _context19.abrupt("return", updatedCart);
          case 11:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _updateShippingProvider.apply(this, arguments);
  }
  function recalculateCart() {
    return _recalculateCart.apply(this, arguments);
  }
  function _recalculateCart() {
    _recalculateCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var updatedCart;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return getCurrentCart();
          case 2:
            _context20.next = 4;
            return client.cart.updateCart.mutate({
              actions: [{
                recalculate: {
                  updateProductData: true
                }
              }]
            });
          case 4:
            updatedCart = _context20.sent;
            updatedCart && setCart(updatedCart);
            return _context20.abrupt("return", updatedCart);
          case 7:
          case "end":
            return _context20.stop();
        }
      }, _callee20);
    }));
    return _recalculateCart.apply(this, arguments);
  }
  function setDeliveryType(_x16) {
    return _setDeliveryType.apply(this, arguments);
  }
  function _setDeliveryType() {
    _setDeliveryType = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref7) {
      var address, idRelai, carrier, serviceType, custom, cleanedAddress, updatedCart;
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            address = _ref7.address, idRelai = _ref7.idRelai, carrier = _ref7.carrier, serviceType = _ref7.serviceType;
            _context21.next = 3;
            return getCurrentCart();
          case 3:
            custom = address.custom, cleanedAddress = _objectWithoutProperties(address, _excluded3);
            carrier = carrier ? JSON.stringify(carrier) : '""';
            serviceType = serviceType ? JSON.stringify(serviceType) : '""';
            _context21.next = 8;
            return client.cart.setDeliveryType.mutate({
              locale: locale,
              currency: currency,
              address: cleanedAddress,
              deliveryMethod: {
                pickupId: idRelai,
                carrier: carrier,
                serviceType: serviceType
              }
            });
          case 8:
            updatedCart = _context21.sent;
            updatedCart && setCart(updatedCart);
            return _context21.abrupt("return", updatedCart);
          case 11:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    return _setDeliveryType.apply(this, arguments);
  }
  return {
    cart: cart,
    loading: readonly(loading),
    error: readonly(error),
    // actions
    load: load,
    clear: clear,
    setCart: setCart,
    addItem: addItem,
    removeItem: removeItem,
    updateItemQty: updateItemQty,
    // getters
    isInCart: isInCart,
    totalPriceCart: totalPriceCart,
    totalPriceItems: totalPriceItems,
    countItems: countItems,
    countItemsWithoutGift: countItemsWithoutGift,
    hasWorkshopsInCart: hasWorkshopsInCart,
    cartExpirationDate: cartExpirationDate,
    cartCoupons: cartCoupons,
    freeShippingCoupons: freeShippingCoupons,
    addItemById: addItemById,
    addItemsById: addItemsById,
    removeItemsIfNotAvailableInCountry: removeItemsIfNotAvailableInCountry,
    setGiftRejection: setGiftRejection,
    addWorkshopToCart: addWorkshopToCart,
    addUtms: addUtms,
    updateCartLocaleAndCountry: updateCartLocaleAndCountry,
    setCustomerEmail: setCustomerEmail,
    updateShippingAddress: updateShippingAddress,
    updateBillingAddress: updateBillingAddress,
    updateShippingProvider: updateShippingProvider,
    recalculateCart: recalculateCart,
    setDeliveryType: setDeliveryType
  };
}